class UniqueService {
  getUniqueId = () => {
    return `id-${Math.random().toString(16).slice(2)}`;
  };
}

export const uniqueService = new UniqueService();
